import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _, { set } from 'lodash';
import { Typography, TableRow, TableCell, IconButton, Collapse, Box, Table, TableHead, TableBody, TableContainer, Paper, LinearProgress, Tooltip, Select, MenuItem, colors, Popover, Grid, useMediaQuery, Tabs, Tab } from '@material-ui/core';
import {ErrorOutline, KeyboardArrowDown,KeyboardArrowUp, Timer} from '@material-ui/icons'
import {  GameModes, IDeath, IGame, IGamePlayer, getPlayerPerformance, getRating } from '@pvplevelup/core/dist/interfaces/Game/IGame';
import { PlayerScore } from './PvPGame';
import { classImages } from 'utilities/ClassImages';
import { AocClasses, getArchetype, AocArchetype } from '@pvplevelup/core/dist/interfaces/ICharacter';
import clsx from 'clsx';
import NumberFormat from 'react-number-format';
import { ResponsiveRadar } from '@nivo/radar'
import { Pie, ResponsivePie } from '@nivo/pie';
import { RadarLabel, RatingType } from 'components/Character/CharacterMatchmakingStats';
import {Star as StarIcon} from '@material-ui/icons'
import { NavLink } from 'react-router-dom';
import { ClassColors, ClassTextColors, TeamColors } from 'utilities/team_colors';
import { hhmmss } from '@pvplevelup/core/dist/utility/time';
import { blackColor } from 'assets/jss/material-dashboard-react';
import SpecIcon from 'assets/images/specicon.png';
import { FeatBuildDialog } from 'components/Feats/FeatBuildDialog';
import { TeamplayPanel } from 'components/Game/TeamplayPanel';
import classNames from 'classnames';
import { AAType, aaImages } from 'utilities/aa';
import { normalize } from 'utilities/normalize';
import {Sword} from 'components/SvgIcons/Sword';
import { Cross } from 'components/SvgIcons/Cross';
import { Shield } from 'components/SvgIcons/Shield';
import { linearGradientDef } from '@nivo/core';
import Color from 'color';
import { ItemComponent } from 'components/ItemComponent';
import { useDeepCompareEffect } from 'components/Map/MapRenderer';
import ReactResizeDetector from 'react-resize-detector';
import { breakPoint } from 'components/Character/CharacterStats';
import { ta } from 'date-fns/locale';

const useStyles = makeStyles(theme => ({
  gameMode: {
    color: 'grey'
  },
  background: {
    background: 'rgba(20, 20, 20, 0.92)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
    borderRadius: 8,
    boxShadow: 'none',
    '& .MuiTableCell-root': {
      borderBottom: '1px solid rgba(255,255,255,0.05)',
    },
  },
  cellRoot:{
    padding: '0px',
  },
  iconContainer:{
    display: "grid",
    justifyContent: "center"
  },
  statHeader: {
    width:'40px',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    opacity: 0.7,
  }
}));

interface Props{
  teamScores: Array<PlayerScore[]>;
  game: IGame;
}

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  justifySelf: {
    justifySelf: 'end'
  },
  valueGrid: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 6,
    padding: "0.6em",
    gap: '.5em',
    fontSize: '1em',
    color: "#c9c9c9"
  },
  valGrid: {
    display: "grid",
    gridTemplateRows: "auto auto",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 6,
    padding: "0.6em",
    gap: '.25em',
    fontSize: '1em',
    color: "#c9c9c9"
  },
  valueRight: {
    alignSelf: 'right'
  },
  season: {
    display: "grid",
    gridTemplateRows: "repeat(7,max-content)"
  },
  mmrGrid: {
    display: "grid",
    gridTemplateColumns: "auto auto auto auto"
  },
  ccgrid: {
    display: "grid",
    gridTemplateColumns: "auto auto auto auto auto"
  },
  ccTakengrid: {
    display: "grid",
    gridTemplateColumns: "auto auto auto auto"
  },
  healgrid: {
    display: "grid",
    gridTemplateColumns: "auto auto auto"
  },
  burstGrid: {
    display: "grid",
    gridTemplateColumns: "auto auto"
  },
  value: {
    fontWeight: 'bold',
    color: "#cca456"
  },
  noTop: {
    borderTop: 0
  },
  noRight: {
    borderRight: 0
  },
  graphs: {
    color: 'black',
    height: '300px',
    marginLeft: '15px',
    marginRight: '15px',
  },
  radarLabel: {
    marginTop: '0.5em',
    color: 'white',
    fontSize: '1.5em',
    letterSpacing: '0.05em',
    fontWeight: 500
  },
  containerGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(auto,475px) auto",
    gridTemplateRows: "auto auto",
    gridGap:'1em',
    marginTop:'1.5em'
  },
  link: {
    textDecoration: "none",
    color: "rgba(255,255,255,0.6)",
    fontSize: '0.8em',
    "&:hover,&:focus": {
      color: "#FFF",
      textDecoration: "underline",
    }
  },
  userlink:{
    fontSize: '1.1em',
    fontWeight: 700,
    textDecoration: "none",
    color: "#ffffff",
    "&:hover,&:focus": {
      textDecoration: "underline",
    }
  },
  classBg:{
    position: 'relative',
    top:0,
    left:0,
  },
  cellRoot:{
    padding: '0px',
  },
  namesContainer:{
    display: 'grid',
    gridTemplateRows: 'max-content max-content',
    padding: '5px 0px',
    width:'135px'
  },
  nCont:{
    position: 'relative',
    top:0,
    left:0,
    width:'260px',
    minWidth:'200px'
  },
  classBgImage:{
    position:'absolute',
    top:0,
    bottom:0,
    backgroundSize: "cover",
    backgroundPosition: "center center",
    zIndex: 0,
    height: "100%",
    width: "100%",
    WebkitMaskImage:"linear-gradient(90deg, transparent 5%, black, transparent 95%)"
  },
  aa:{
    display: 'grid',
    gridTemplateColumns: "max-content max-content max-content max-content max-content max-content max-content",
    gridGap: "3px",
    padding:'10px 0px',
  },
  icon:{
    width:'35px',
    height:'35px',
    verticalAlign:'center'
  },
  disabledIcon:{
    opacity:0.35
  },
  twoStatContainer:{
    display: 'grid',
    gridTemplateRows: "auto auto",
    justifyContent: 'center',
    gridTemplateColumns: 'minmax(110px,auto)',
    margin: '0px 5px'
  },
  twoStatCompactContainer:{
    display: 'grid',
    gridTemplateRows: "auto auto",
    justifyContent: 'center',
  },
  boldText:{
    fontSize: '1.15em',
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
  },
  greyText:{
    color:"#b0b0b0"
  },
  barRoot:{
    height:'4px',
    borderRadius: 2,
    background:'rgba(255,255,255,0.1)',
    margin:'6px 0'
  },
  barBar:{
    borderRadius: 2,
    background:'rgba(255,255,255,0.75)'
  },
  statContainer:{
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    columnGap: '2em',
    rowGap: '0.5em',
    gridAutoRows: 'max-content',
    gridAutoFlow: 'row',
  },
  leftStat:{
    justifySelf: 'start'
  },
  rightStat:{
    justifySelf: 'start'
  },
  pieContainer:{
    marginTop:'1.5em',
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridTemplateRows: 'max-content auto',
    rowGap: '1em',
    color: 'black',
    columnGap: '1em'
  },
  headerUnderline:{
    borderBottom: "1px solid rgba(255,255,255,0.12)",
    paddingBottom: "5px",
    color: "#ffffff",
    fontSize: '0.8rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  headerUnderline2:{
    borderBottom: "1px solid #5d5d5dc4",
    paddingBottom: "5px",
    marginTop: '10px',
    marginBottom: '10px',
    color: "#a3e2df",
  },
  popover: {
    pointerEvents: 'none',
  }
});

export const ratingColorMap = {
  "S+": "#ead033",
  "S": "#ead033",
  "S-": "#ead033",
  "A+": "#cf3721",
  "A": "#cf3721",
  "A-": "#cf3721",
  "B+": "#ac1be0",
  "B": "#ac1be0",
  "B-": "#ac1be0",
  "C+": "#4391e1",
  "C": "#4391e1",
  "C-": "#4391e1",
  "D+": "#4cece9",
  "D": "#4cece9",
  "D-": "#4cece9",
  "E+": "#0ddf76",
  "E": "#0ddf76",
  "F": "#c0c0bf"
}

export function getRatingComponent(_rating: number){
  let rating = getRating(_rating);
  return <span style={{color:ratingColorMap[rating]}}>{rating}</span>;
}

/** The damage charts' slice for victims who aren't players in the game. */
const OTHERS_SLICE = "Others";
const OTHERS_COLOR = "#757575";

function Row(props: { row: PlayerScore, player: IGamePlayer, game: IGame, matches: boolean }) {
  const { row, player,game,matches } = props;
  const {players,deaths,info} = game;
  const [open, setOpen] = React.useState(false);
  const [damageData,setDamageData] = React.useState<PieData[]>([]);
  const [damageAgainstData,setDamageAgainstData] = React.useState<PieData[]>([]);
  const [edamageData,setEDamageData] = React.useState<PieData[]>([]);
  const [edamageAgainstData,setEDamageAgainstData] = React.useState<PieData[]>([]);
  const [killData,setKillData] = React.useState<PieData[]>([]);
  const [killAgainstData,setKillAgainstData] = React.useState<PieData[]>([]);
  const [ekillData,setEKillData] = React.useState<PieData[]>([]);
  const [ekillAgainstData,setEKillAgainstData] = React.useState<PieData[]>([]);
  const [assistData,setAssistData] = React.useState<PieData[]>([]);
  const [assistAgainstData,setAssistAgainstData] = React.useState<PieData[]>([]);
  const [eassistData,setEAssistData] = React.useState<PieData[]>([]);
  const [eassistAgainstData,setEAssistAgainstData] = React.useState<PieData[]>([]);
  const [fblowData,setFblowData] = React.useState<PieData[]>([]);
  const [fblowAgainstData,setFblowAgainstData] = React.useState<PieData[]>([]);
  const [currentMe, setCurrentMe] = React.useState<number>(0);
  const [currentAgainst, setCurrentAgainst] = React.useState<number>(0);
  const [tabValue, setTabValue] = React.useState<number>(0);
  const [featsOpen, setFeatsOpen] = React.useState(false);
  const classes = useRowStyles();
  const currPlayer = player;

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const illegalOpen = Boolean(anchorEl);

  let data:any = [];
  if(player && player.name){
    let offenseObj: any = {"rating": RatingType.Offense}
    offenseObj[player.name] = player?.oRating;
    let defenseObj: any = {"rating": RatingType.Defense}
    defenseObj[player.name] = player.dRating;
    let supportObj: any = {"rating": RatingType.Support}
    supportObj[player.name] = player.sRating;
    data = [offenseObj,defenseObj,supportObj];
  }

  let archetype = getArchetype(player?.class || "");
  let hasEkills = players?.find((p)=>(p.eKills || 0) > 0) != null;
  let hasCCsTaken = players?.find((p)=>(p.ccsTaken || 0) > 0) != null;
  let hasEDamage = players?.find((p)=>(p.eDamage || 0) > 0) != null;
  let performance = getPlayerPerformance(player,game,hasEkills,hasCCsTaken,hasEDamage);

  let testData:any = [{
    "rating": "Kills",
    [player?.name || ""]: Math.round(performance.kills * 100)
  },
  {
    "rating": "Damage",
    [player?.name || ""]: Math.round(performance.damage * 100)
  },
  {
    "rating": "Assists",
    [player?.name || ""]: Math.round(performance.assists * 100)
  },
  {
    "rating": "Crowd Controls",
    [player?.name || ""]: Math.round(performance.ccs * 100)
  },
  {
    "rating": "Defense",
    [player?.name || ""]: Math.round(performance.defense * 100)
  }
];

  if(archetype == AocArchetype.Priest){
    testData.push({"rating": 'Healing', [player?.name || ""]: Math.round((((player?.nheal || 0) * 0.75 + (player?.neBigHeal || 0) * 0.25)) * 100)});
  }
  
  let damages = players?.filter((p)=>p.team == player?.team).map((p)=>p.damage || 0) || [];
  damages.sort((a,b)=>b-a);
  let dmgpct = normalize(player?.damage || 0,0, damages[0]);

  let damageTakens = players?.filter((p)=>p.team == player?.team).map((p)=>p.dTaken || 0) || [];
  damageTakens.sort((a,b)=>b-a);
  let dmgTakenpct = normalize(player?.dTaken || 0,0, damageTakens[0]);

  let ccs = players?.filter((p)=>p.team == player?.team).map((p)=>p.ccs || 0) || [];
  ccs.sort((a,b)=>b-a);
  let ccspct = normalize(player?.ccs || 0,0, ccs[0]);

  let timeInObjectives = players?.filter((p)=>p.team == player?.team).map((p)=>p.timeInObjective || 0) || [];
  timeInObjectives.sort((a,b)=>b-a);
  let tiopct = normalize(player?.timeInObjective || 0,0, timeInObjectives[0]);
  let playerNames = players?.map((p)=>p.name || "") || []

  function getPieData(deaths:IDeath[],extraDamage: boolean = false){
    let _damageData: PieData[] = [];
    let _damageAgainstData: PieData[] = [];
    let _edamageData: PieData[] = [];
    let _edamageAgainstData: PieData[] = [];
    let _killData: PieData[] = [];
    let _killAgainstData: PieData[] = [];
    let _ekillData: PieData[] = [];
    let _ekillAgainstData: PieData[] = [];
    let _assistData: PieData[] = [];
    let _assistAgainstData: PieData[] = [];
    let _eassistData: PieData[] = [];
    let _eassistAgainstData: PieData[] = [];
    let _fblowData: PieData[] = [];
    let _fblowAgainstData: PieData[] = [];
    for(let death of deaths){
      let filteredDamage = death?.damage?.filter((d)=>playerNames.includes(d.name || "")) || [];
      let filteredEDamage = death?.eDamage?.filter((d)=>playerNames.includes(d.name || "")) || [];
      if(death.victim?.name == player?.name){
        let groupedDamage = _.groupBy(filteredDamage,(d)=>d.name);
        for(let key in groupedDamage){
          let foundPlayer = players?.find((p)=>p.name == key);
          let _class = (foundPlayer?.class || "") as AocClasses;
          let foundDamageTakenData = _damageAgainstData.find((d)=>d.id == key);
          if(foundDamageTakenData){
            foundDamageTakenData.value += groupedDamage[key].reduce((a,b)=>a + (b.value || 0),0);
          }else{
            let foundClassCount = _damageAgainstData.filter((d)=>d.class == _class).length;
            _damageAgainstData.push({
              id: foundPlayer?.name || "",
              value: groupedDamage[key].reduce((a,b)=>a + (b.value || 0),0),
              color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
              label: foundPlayer?.name || "",
              textColor: ClassTextColors(_class),
              class: _class
            });
          }
        }
        if(extraDamage == false){
          let foundKillAgainstData = _killAgainstData.find((d)=>d.id == death.killed_by?.name);
          if(foundKillAgainstData){
            foundKillAgainstData.value += 1;
          }else{
            let foundPlayer = players?.find((p)=>p.name == death.killed_by?.name);
            let _class = (foundPlayer?.class || "") as AocClasses;
            let foundClassCount = _killAgainstData.filter((d)=>d.class == _class).length;
            _killAgainstData.push({
              id: death.killed_by?.name || "",
              value: 1,
              color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
              label: foundPlayer?.name || "",
              textColor: ClassTextColors(_class),
              class: _class
            });
          }
          if(death.eKill != null){
            let foundeKillAgainstData = _ekillAgainstData.find((d)=>d.id == death.eKill);
            if(foundeKillAgainstData){
              foundeKillAgainstData.value += 1;
            }else{
              let foundPlayer = players?.find((p)=>p.name == death.eKill);
              let _class = (foundPlayer?.class || "") as AocClasses;
              let foundClassCount = _ekillAgainstData.filter((d)=>d.class == _class).length;
              _ekillAgainstData.push({
                id: death.eKill || "",
                value: 1,
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
          let foundfblowAgainstData = _fblowAgainstData.find((d)=>d.id == death.fBlow);
          if(foundfblowAgainstData){
            foundfblowAgainstData.value += 1;
          }else{
            let foundPlayer = players?.find((p)=>p.name == death.fBlow);
            let _class = (foundPlayer?.class || "") as AocClasses;
            let foundClassCount = _fblowAgainstData.filter((d)=>d.class == _class).length;
            _fblowAgainstData.push({
              id: death.fBlow || "",
              value: 1,
              color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
              label: foundPlayer?.name || "",
              textColor: ClassTextColors(_class),
              class: _class
            });
          }
          for(let assist of (death.assists || [])){
            let foundassistAgainstData = _assistAgainstData.find((d)=>d.id == assist);
            if(foundassistAgainstData){
              foundassistAgainstData.value += 1;
            }else{
              let foundPlayer = players?.find((p)=>p.name == assist);
              let _class = (foundPlayer?.class || "") as AocClasses;
              let foundClassCount = _assistAgainstData.filter((d)=>d.class == _class).length;
              _assistAgainstData.push({
                id: assist || "",
                value: 1,
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
          for(let eassist of (death.eAssists || [])){
            let foundeassistAgainstData = _eassistAgainstData.find((d)=>d.id == eassist);
            if(foundeassistAgainstData){
              foundeassistAgainstData.value += 1;
            }else{
              let foundPlayer = players?.find((p)=>p.name == eassist);
              let _class = (foundPlayer?.class || "") as AocClasses;
              let foundClassCount = _eassistAgainstData.filter((d)=>d.class == _class).length;
              _eassistAgainstData.push({
                id: eassist || "",
                value: 1,
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
          let groupedEDamage = _.groupBy(filteredEDamage,(d)=>d.name);
          for(let key in groupedEDamage){
            let foundEPlayer = players?.find((p)=>p.name == key);
            let _class = (foundEPlayer?.class || "") as AocClasses;
            let foundeDamageTakenData = _edamageAgainstData.find((d)=>d.id == key);
            if(foundeDamageTakenData){
              foundeDamageTakenData.value += groupedEDamage[key].reduce((a,b)=>a + (b.value || 0),0);
            }else{
              let foundClassCount = _edamageAgainstData.filter((d)=>d.class == _class).length;
              _edamageAgainstData.push({
                id: key,
                value: groupedEDamage[key].reduce((a,b)=>a + (b.value || 0),0),
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundEPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
        }
      }else{
        let groupedDamage = _.groupBy(filteredDamage,(d)=>d.name);
        let myDamage = groupedDamage[player?.name || ""];
        if(myDamage != null){
          let foundPlayer = players?.find((p)=>p.name == death.victim?.name);
          let _class = (foundPlayer?.class || "") as AocClasses;
          // victims outside this game's players (npcs, passers-by) share one slice instead of one blank slice per death
          let sliceId = foundPlayer?.name || OTHERS_SLICE;
          let foundDamageData = _damageData.find((d)=>d.id == sliceId);
          if(foundDamageData){
            foundDamageData.value += myDamage.reduce((a,b)=>a + (b.value || 0),0);
          }else{
            let foundClassCount = _damageData.filter((d)=>d.class == _class).length;
            _damageData.push({
              id: sliceId,
              value: myDamage.reduce((a,b)=>a + (b.value || 0),0),
              color: foundPlayer ? Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex() : OTHERS_COLOR,
              label: sliceId,
              textColor: ClassTextColors(_class),
              class: _class
            });
          }
        }
        if(extraDamage == false){
          if(death.killed_by?.name == player?.name){
            let foundKillData = _killData.find((d)=>d.id == death.victim?.name);
            if(foundKillData){
              foundKillData.value += 1;
            }else{
              let foundPlayer = players?.find((p)=>p.name == death.victim?.name);
              let _class = (foundPlayer?.class || "") as AocClasses;
              let foundClassCount = _killData.filter((d)=>d.class == _class).length;
              _killData.push({
                id: death.victim?.name || "",
                value: 1,
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
          if(death.eKill == player?.name){
            let foundeKillData = _ekillData.find((d)=>d.id == death.victim?.name);
            if(foundeKillData){
              foundeKillData.value += 1;
            }else{
              let foundPlayer = players?.find((p)=>p.name == death.victim?.name);
              let _class = (foundPlayer?.class || "") as AocClasses;
              let foundClassCount = _ekillData.filter((d)=>d.class == _class).length;
              _ekillData.push({
                id: death.victim?.name || "",
                value: 1,
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
          if(death.fBlow == player?.name){
            let foundfblowData = _fblowData.find((d)=>d.id == death.victim?.name);
            if(foundfblowData){
              foundfblowData.value += 1;
            }else{
              let foundPlayer = players?.find((p)=>p.name == death.victim?.name);
              let _class = (foundPlayer?.class || "") as AocClasses;
              let foundClassCount = _fblowData.filter((d)=>d.class == _class).length;
              _fblowData.push({
                id: death.victim?.name || "",
                value: 1,
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
          let assist = death.assists?.find((a)=>a == player?.name);
          if(assist){
            let foundassistData = _assistData.find((d)=>d.id == death.victim?.name);
            if(foundassistData){
              foundassistData.value += 1;
            }else{
              let foundPlayer = players?.find((p)=>p.name == death.victim?.name);
              let _class = (foundPlayer?.class || "") as AocClasses;
              let foundClassCount = _assistData.filter((d)=>d.class == _class).length;
              _assistData.push({
                id: death.victim?.name || "",
                value: 1,
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
          let eassist = death.eAssists?.find((a)=>a == player?.name);
          if(eassist){
            let foundeassistData = _eassistData.find((d)=>d.id == death.victim?.name);
            if(foundeassistData){
              foundeassistData.value += 1;
            }else{
              let foundPlayer = players?.find((p)=>p.name == death.victim?.name);
              let _class = (foundPlayer?.class || "") as AocClasses;
              let foundClassCount = _eassistData.filter((d)=>d.class == _class).length;
              _eassistData.push({
                id: death.victim?.name || "",
                value: 1,
                color: Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex(),
                label: foundPlayer?.name || "",
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
          let eDamage = filteredEDamage?.filter((d)=>d.name == player?.name) || [];
          if(eDamage?.length > 0){
            let foundEPlayer = players?.find((p)=>p.name == death.victim?.name);
            let _class = (foundEPlayer?.class || "") as AocClasses;
            let sliceId = foundEPlayer?.name || OTHERS_SLICE;
            let foundeDamageTakenData = _edamageData.find((d)=>d.id == sliceId);
            if(foundeDamageTakenData){
              foundeDamageTakenData.value += eDamage.reduce((a,b)=>a + (b.value || 0),0);
            }else{
              let foundClassCount = _edamageData.filter((d)=>d.class == _class).length;
              _edamageData.push({
                id: sliceId,
                value: eDamage.reduce((a,b)=>a + (b.value || 0),0),
                color: foundEPlayer ? Color(ClassColors(_class)).darken(foundClassCount * 0.1).hex() : OTHERS_COLOR,
                label: sliceId,
                textColor: ClassTextColors(_class),
                class: _class
              });
            }
          }
        }
      }
    }
    return {
      damage:_damageData,
      damageAgainst:_damageAgainstData,
      edamage:_edamageData,
      edamageAgainst:_edamageAgainstData,
      kill:_killData,
      killAgainst:_killAgainstData,
      ekill:_ekillData,
      ekillAgainst:_ekillAgainstData,
      assist:_assistData,
      assistAgainst:_assistAgainstData,
      eassist:_eassistData,
      eassistAgainst:_eassistAgainstData,
      fblow:_fblowData,
      fblowagainst:_fblowAgainstData,
    }
  }

  useDeepCompareEffect(()=>{
    if(open){
      
      let deathPieData = getPieData(deaths || []);
      let damagePieData = getPieData(info?.extraDamage || [], true);

      damagePieData.damage.forEach((d)=>{
        let found = deathPieData.damage.find((dd)=>dd.id == d.id);
        if(found){
          found.value += d.value;
        }else{
          deathPieData.damage.push(d);
        }
      })
      damagePieData.damageAgainst.forEach((d)=>{
        let found = deathPieData.damageAgainst.find((dd)=>dd.id == d.id);
        if(found){
          found.value += d.value;
        }else{
          deathPieData.damageAgainst.push(d);
        }
      })

      setDamageData(deathPieData.damage);
      setDamageAgainstData(deathPieData.damageAgainst);
      setEDamageData(deathPieData.edamage);
      setEDamageAgainstData(deathPieData.edamageAgainst);
      setKillData(deathPieData.kill);
      setKillAgainstData(deathPieData.killAgainst);
      setEKillData(deathPieData.ekill);
      setEKillAgainstData(deathPieData.ekillAgainst);
      setAssistData(deathPieData.assist);
      setAssistAgainstData(deathPieData.assistAgainst);
      setEAssistData(deathPieData.eassist);
      setEAssistAgainstData(deathPieData.eassistAgainst);
      setFblowData(deathPieData.fblow);
      setFblowAgainstData(deathPieData.fblowagainst);
    }
  },[deaths,open])
  
  let currentMePie:PieData[] = [], currentAgainstPie:PieData[] = [];
  switch(currentMe){
    case 0:
      currentMePie = damageData;
      break;
    case 1:
      currentMePie = edamageData;
      break;
    case 2:
      currentMePie = killData;
      break;
    case 3:
      currentMePie = ekillData;
      break;
    case 4:
      currentMePie = assistData;
      break;
    case 5:
      currentMePie = eassistData;
      break;
    case 6:
      currentMePie = fblowData;
      break;
  }

  switch(currentAgainst){
    case 0:
      currentAgainstPie = damageAgainstData;
      break;
    case 1:
      currentAgainstPie = edamageAgainstData;
      break;
    case 2:
      currentAgainstPie = killAgainstData;
      break;
    case 3:
      currentAgainstPie = ekillAgainstData;
      break;
    case 4:
      currentAgainstPie = assistAgainstData;
      break;
    case 5:
      currentAgainstPie = eassistAgainstData;
      break;
    case 6:
      currentAgainstPie = fblowAgainstData;
      break;
  }

  const mobile = useMediaQuery(`(max-width:${500}px)`);

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell classes={{root:classes.cellRoot}} className={!mobile ? classes.nCont : ""} style={{borderLeft:`4px solid ${TeamColors[player?.team || 0]}`}}>
          <Tooltip title={`${player?.rating}`} aria-label="rating"><Typography style={{marginLeft:'5px',fontSize:'1.5em',fontWeight:'bolder',zIndex:1}}>{getRatingComponent(player?.rating || 0)}</Typography></Tooltip>
          {!mobile && <div style={{backgroundImage: `url(${classImages.getBackground(row.class as AocClasses)})`}} className={classNames(classes.classBgImage)} /> }
        </TableCell>
        <TableCell align={"left"} classes={{root:classes.cellRoot}}>
          <div className={classes.namesContainer} style={{gridTemplateColumns:'1fr auto', columnGap:'8px', alignItems:'center'}}>
            <NavLink to={`/characters/${row.character_id}`} className={classes.userlink} style={{gridColumn:1}}>{row.name}</NavLink>
            <NavLink to={`/users/${player?.user?._id}`} className={classes.link} style={{gridColumn:1}}>{player?.user?.displayname}</NavLink>
            {
              player.illegal &&
                <IconButton
                  onMouseEnter={handlePopoverOpen}
                  onMouseLeave={handlePopoverClose}
                  style={{gridColumn:2, gridRow:'1 / span 2', padding:0}}
                >
                  <ErrorOutline style={{color:colors.orange[300]}} />
                </IconButton>
            }
          </div>
        </TableCell>
        <TableCell align={"center"} classes={{root:classes.cellRoot}}>
          <div className={classes.boldText}>{row.kills}</div>
        </TableCell>
        <TableCell align={"center"} classes={{root:classes.cellRoot}}>
          <div className={classes.boldText}>{row.deaths}</div>
        </TableCell>
        <TableCell align={"center"} classes={{root:classes.cellRoot}}>
          <div className={classes.boldText}>{row.assists}</div>
        </TableCell>
        <TableCell align={"center"} classes={{root:classes.cellRoot}}>
          <div className={classes.boldText}>{row.eKills}</div>
        </TableCell>
        <TableCell align={"center"} classes={{root:classes.cellRoot}}>
          <div className={classes.boldText}>{row.eAssists}</div>
        </TableCell>
        {!matches &&
          <React.Fragment>
            <TableCell align={"center"} classes={{root:classes.cellRoot}}>
              <div className={classes.twoStatContainer}>
                <div className={classes.boldText} title="Total Damage Dealt">
                  <NumberFormat value={player?.damage} displayType={'text'} thousandSeparator={true} decimalScale={2} />
                </div>
                <div>
                  <LinearProgress title='Damage relative to teammates' variant="determinate" classes={{root:classes.barRoot,bar:classes.barBar}} value={dmgpct * 100} />
                </div>
                
              </div>
            </TableCell>
            <TableCell align={"center"} classes={{root:classes.cellRoot}}>
              <div className={classes.twoStatContainer}>
                <div className={classes.boldText} title='Total Damage Taken'>
                  <NumberFormat value={player?.dTaken} displayType={'text'} thousandSeparator={true} decimalScale={2} />
                </div>
                <div>
                  <LinearProgress title='Damage Taken relative to teammates' variant="determinate" classes={{root:classes.barRoot,bar:classes.barBar}} value={dmgTakenpct * 100} />
                </div>
                
              </div>
            </TableCell>
            <TableCell align={"center"} classes={{root:classes.cellRoot}}>
              <div className={classes.twoStatContainer}>
                <div className={classes.boldText}>
                  <span title="Total Crowd Controls">{player?.ccs}</span> / <span title="Crowd Controls leading to a kill">{player?.oCCs}</span> / <span title="Crowd Controls that save a teammate">{player?.dCCs}</span>
                </div>
                <div>
                  <LinearProgress title='Crowd Controls dealt realtive to teammates' variant="determinate" classes={{root:classes.barRoot,bar:classes.barBar}} value={ccspct * 100} />
                </div>
                
              </div>
            </TableCell>
            {(player?.timeInObjective || 0) > 0 &&
              <TableCell align="center" classes={{root:classes.cellRoot}}>
                <div className={classes.twoStatCompactContainer}>
                  <div className={classes.boldText} title='Time in Objective'>
                    {hhmmss((player?.timeInObjective || 0),false)}
                  </div>
                  <div>
                    <LinearProgress title="Time in Objective relative to teammates" variant="determinate" classes={{root:classes.barRoot,bar:classes.barBar}} value={tiopct * 100} />
                  </div>
                </div>
              </TableCell>
            }
          </React.Fragment>
        }
        <TableCell align="right" classes={{root:classes.cellRoot}}>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell  classes={{root:classes.cellRoot}} style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Tabs value={tabValue} onChange={(e,value)=>{
              setTabValue(value);
            }}>
              <Tab label="Performance" />
              <Tab label="Graphs" />
              {(game?.trackingVersion || 0) >= 2 && <Tab label="Team Play" />}
            </Tabs>
            <Grid container style={{padding:'10px'}}>
              {tabValue == 0 &&
                <React.Fragment>
                  <Grid container item sm={12} style={{marginBottom:'15px'}}>
                    <Grid item xs={12} md={4}>
                      <Typography variant='h6' className={classes.headerUnderline}>Rating</Typography>
                      <div className={classes.aa}>
                        <img src={SpecIcon} onClick={(e)=>{
                          e.preventDefault();
                          if(player?.spec)
                            setFeatsOpen(true);
                        }} style={{cursor: player?.spec == null || player?.spec == "" ? 'initial' : 'pointer'}} className={classNames(classes.icon,{
                          [classes.disabledIcon]: player?.spec == null || player?.spec == ""
                        })} title='Feat build' />
                        <FeatBuildDialog open={featsOpen} onClose={() => setFeatsOpen(false)} title={`${player?.name || ''}'s feats`} spec={player?.spec} />
                        {_.times(6,(num)=>{
                          let image = "", aa = "";
                          if(num == 0 || num == 1){
                            let generalAA = player?.aa?.filter((aa)=>aaImages.getAAInfo(aa).type == AAType.General) || [];
                            if(generalAA?.length == 0){
                              image = aaImages.getAA("GeneralAA");
                            }else if(num == 0 && generalAA?.length > 0){
                              image = aaImages.getAA(generalAA[0]);
                              aa = generalAA[0];
                            }else if(num == 1 && generalAA?.length > 1){
                              image = aaImages.getAA(generalAA[1]);
                              aa = generalAA[1];
                            }else{
                              image = aaImages.getAA("GeneralAA");
                            }
                          }
                          if(num == 2 || num == 3){
                            let archetypeAA = player?.aa?.filter((aa)=>aaImages.getAAInfo(aa).type == AAType.Archetype) || [];
                            if(archetypeAA?.length == 0){
                              image = aaImages.getAA("ArchetypeAA");
                            }else if(num == 2 && archetypeAA?.length > 0){
                              image = aaImages.getAA(archetypeAA[0]);
                              aa = archetypeAA[0];
                            }else if(num == 3 && archetypeAA?.length > 1){
                              image = aaImages.getAA(archetypeAA[1]);
                              aa = archetypeAA[1];
                            }else{
                              image = aaImages.getAA("ArchetypeAA");
                            }
                          }
                          if(num == 4 || num == 5){
                            let classAA = player?.aa?.filter((aa)=>aaImages.getAAInfo(aa).type == AAType.Class) || [];
                            if(classAA?.length == 0){
                              image = aaImages.getAA("ClassAA");
                            }else if(num == 4 && classAA?.length > 0){
                              image = aaImages.getAA(classAA[0]);
                              aa = classAA[0];
                            }else if(num == 5 && classAA.length == 1 && aaImages.getAAInfo(classAA[0]).size == 2){
                              image = aaImages.getAA(classAA[0]);
                              aa = classAA[0];
                            }else if(num == 5 && classAA?.length > 1){
                              image = aaImages.getAA(classAA[1]);
                              aa = classAA[1];
                            }else{
                              image = aaImages.getAA("ClassAA");
                            }
                          }
                          return (
                            <img src={image} title={aa} className={classNames(classes.icon)} />
                          )
                        })}
                      </div>
                      <div className={classes.graphs}>
                        <ResponsiveRadar
                          /* 
                          // @ts-ignore */
                          theme={{
                              "axis": {
                                  "ticks": {
                                      "text": {
                                          "fontSize": 14,
                                          "fill": "#ffffff",
                                          "outlineWidth": 0,
                                          "outlineColor": "transparent"
                                      }
                                  }
                              },
                              "grid": {
                                "line": {
                                  "stroke":"#8c9e9e",
                                  strokeWidth: '1px'
                                }
                              }
                          }}
                          colors={"#f5d020"}
                          data={testData}
                          keys={[ player?.name || "" ]}
                          indexBy="rating"
                          maxValue={100}
                          borderWidth={2}
                          defs={[
                            linearGradientDef(
                              'gradientC',
                              [
                                { offset: 0, color: '#f5d020' },
                                { offset: 100, color: '#f53803' },
                              ]
                            )
                          ]}
                          fill={[
                            { match: { id: player?.name || "" }, id: 'gradientC' },
                            { match: "*" , id: 'gradientC' },
                          ]}
                          margin={{ top: 40, right: 60, bottom: 40, left: 60 }}
                          curve="linearClosed"
                          borderColor={{from:"color", modifiers: [['opacity', 0.6],['darker',0.2]]}}
                          gridLevels={1}
                          gridShape="linear"
                          gridLabelOffset={5}
                          enableDots={true}
                          dotSize={6}
                          dotColor={"#f5d020"}
                          dotBorderWidth={2}
                          dotBorderColor={{ from: 'color' }}
                          enableDotLabel={false}
                          dotLabel="value"
                          fillOpacity={0.5}
                          blendMode="normal"
                          animate={true}
                          isInteractive={true}
                          legends={[
                          ]}
                          
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Typography variant='h6' className={classes.headerUnderline}>Stats</Typography>
                      <Grid container item sm={12}>
                        <Grid item xs={12} sm={12} md={6}>
                          <Typography variant='body1' className={classes.headerUnderline2}>Offense</Typography>
                          <div className={classes.statContainer}>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.dps}</div>
                            <div className={classes.rightStat}>DPS</div>
                            <div className={clsx(classes.leftStat,classes.value)}><NumberFormat value={player?.damage} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
                            <div className={classes.rightStat}>Damage</div>
                            <div className={clsx(classes.leftStat,classes.value)}><NumberFormat value={player?.eDamage} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
                            <div className={classes.rightStat}>Effective Damage</div>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.fBlows}</div>
                            <div className={classes.rightStat}>Finishing Blows</div>
                            <div className={clsx(classes.leftStat,classes.value)}><NumberFormat value={player?.peakburst} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
                            <div className={classes.rightStat}>Peak Burst</div>
                            <div className={clsx(classes.leftStat,classes.value)}><NumberFormat value={player?.avgburst} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
                            <div className={classes.rightStat}>Average Burst</div>
                          </div>
                          <Typography variant='body1' className={classes.headerUnderline2}>Defense</Typography>
                          <div className={classes.statContainer}>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.dtps}</div>
                            <div className={classes.rightStat}>Damage Taken Per Second</div>
                            <div className={clsx(classes.leftStat,classes.value)}><NumberFormat value={player?.dTaken} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
                            <div className={classes.rightStat}>Damage Taken</div>
                            <div className={clsx(classes.leftStat,classes.value)}><NumberFormat value={player?.dPD} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
                            <div className={classes.rightStat}>Damage Taken per Death</div>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.ccsTaken}</div>
                            <div className={classes.rightStat}>Total Crowd Controls Taken</div>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.oCCsTaken}</div>
                            <div className={classes.rightStat}>Offensive Crowd Controls Taken</div>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.dCCsTaken}</div>
                            <div className={classes.rightStat}>Defensive Crowd Controls Taken</div>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Typography variant='body1' className={classes.headerUnderline2}>Objective</Typography>
                          <div className={classes.statContainer}>
                            <div className={clsx(classes.leftStat,classes.value)}>{hhmmss(player?.playtime || 0)}</div>
                            <div className={classes.rightStat}>Time in Combat</div>
                            {
                              player?.timeInObjective != null && player?.timeInObjective > 0 &&
                              <React.Fragment>
                                <div className={clsx(classes.leftStat,classes.value)}>{hhmmss(player?.timeInObjective || 0)}</div>
                                <div className={classes.rightStat}>Time in Objective</div>
                              </React.Fragment>
                            }
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.isPlacement ? "Placement" : player?.mmr}</div>
                            <div className={classes.rightStat}>Mmr</div>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.rating}</div>
                            <div className={classes.rightStat}>Performance</div>
                          </div>
                          <Typography variant='body1' className={classes.headerUnderline2}>Support</Typography>
                          <div className={classes.statContainer}>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.ccs}</div>
                            <div className={classes.rightStat}>Total Crowd Controls</div>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.oCCs}</div>
                            <div className={classes.rightStat}>Offensive Crowd Controls</div>
                            <div className={clsx(classes.leftStat,classes.value)}>{player?.dCCs}</div>
                            <div className={classes.rightStat}>Defensive Crowd Controls</div>
                            
                          </div>
                          {
                            (player.class == AocClasses.BearShaman || player.class == AocClasses.PriestofMitra || player.class == AocClasses.TempestofSet) &&
                              <React.Fragment>
                                <Typography variant='body1' className={classes.headerUnderline2}>Healing</Typography>
                                <div className={classes.statContainer}>
                                  <div className={clsx(classes.leftStat,classes.value)}>{player?.hps}</div>
                                  <div className={classes.rightStat}>HPS</div>
                                  <div className={clsx(classes.leftStat,classes.value)}><NumberFormat value={player?.heal} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
                                  <div className={classes.rightStat}>Healing</div>
                                  <div className={clsx(classes.leftStat,classes.value)}>{player?.eBigHeal}</div>
                                  <div className={classes.rightStat}>Effective Big Heals</div>
                                </div>
                              </React.Fragment>
                          }
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </React.Fragment>
              }
              {tabValue == 2 && (game?.trackingVersion || 0) >= 2 &&
                <Grid item xs={12}>
                  <TeamplayPanel player={player} game={game} />
                </Grid>
              }
              {tabValue == 1 &&
                <React.Fragment>
                  <Grid container item sm={12}>
                    <Grid item xs={12} md={6} style={{color:'black'}}>
                      <Select
                        style={{paddingBottom: "5px"}}
                        fullWidth
                        value={currentMe}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                        onChange={(e)=>{
                          setCurrentMe(e.target.value as number);
                        }}>
                        <MenuItem value={0} disabled={damageData.length == 0}>Damage</MenuItem>
                        <MenuItem value={1} disabled={edamageData.length == 0}>Effective Damage</MenuItem>
                        <MenuItem value={2} disabled={killData.length == 0}>Kills</MenuItem>
                        <MenuItem value={3} disabled={ekillData.length == 0}>Effective Kills</MenuItem>
                        <MenuItem value={4} disabled={assistData.length == 0}>Assists</MenuItem>
                        <MenuItem value={5} disabled={eassistData.length == 0}>Effective Assists</MenuItem>
                        <MenuItem value={6} disabled={fblowData.length == 0}>Finishing Blows</MenuItem>
                      </Select>
                      <div style={{height:'300px',margin:'15px'}}>
                        <ResponsivePie
                          colors={(datum)=>datum.data.color}
                          data={currentMePie}
                          theme={{
                            fontSize: 14,
                          }}
                          margin={{ top: 20, right: 120, bottom: 20, left: 120 }}
                          sortByValue={true}
                          innerRadius={0.5}
                          cornerRadius={5}
                          activeOuterRadiusOffset={14}
                          borderWidth={1}
                          borderColor={{
                              from: 'color',
                              modifiers: [
                                  [
                                      'darker',
                                      0.2
                                  ]
                              ]
                          }}
                          arcLinkLabelsSkipAngle={10}
                          arcLinkLabelsTextColor={"#ffffff"}
                          arcLinkLabelsStraightLength={10}
                          arcLinkLabelsColor={{ from: 'color' }}
                          arcLabelsSkipAngle={10}
                          arcLabelsTextColor={(d)=>d.data.textColor}
                          arcLabel={(d)=>`${d.value.toLocaleString('en-US', {maximumFractionDigits:2})}`}
                          legends={[]}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={6} style={{color:'black'}}>
                      <Select
                        style={{paddingBottom: "5px"}}
                        fullWidth
                        value={currentAgainst}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                        onChange={(e)=>{
                          setCurrentAgainst(e.target.value as number);
                        }}>
                        <MenuItem value={0} disabled={damageAgainstData.length == 0}>Damage on {player?.name}</MenuItem>
                        <MenuItem value={1} disabled={edamageAgainstData.length == 0}>Effective Damage on {player?.name}</MenuItem>
                        <MenuItem value={2} disabled={killAgainstData.length == 0}>Kills on {player?.name}</MenuItem>
                        <MenuItem value={3} disabled={ekillAgainstData.length == 0}>Effective Kills on {player?.name}</MenuItem>
                        <MenuItem value={4} disabled={assistAgainstData.length == 0}>Assists on {player?.name}</MenuItem>
                        <MenuItem value={5} disabled={eassistAgainstData.length == 0}>Effective Assists on {player?.name}</MenuItem>
                        <MenuItem value={6} disabled={fblowAgainstData.length == 0}>Finishing Blows on {player?.name}</MenuItem>
                      </Select>
                      <div style={{height:'300px',margin:'15px'}}>
                        <ResponsivePie
                          colors={(datum)=>datum.data.color}
                          data={currentAgainstPie}
                          theme={{
                            fontSize: 14,
                          }}
                          margin={{ top: 20, right: 120, bottom: 20, left: 120 }}
                          sortByValue={true}
                          innerRadius={0.5}
                          cornerRadius={5}
                          activeOuterRadiusOffset={14}
                          borderWidth={1}
                          borderColor={{
                              from: 'color',
                              modifiers: [
                                  [
                                      'darker',
                                      0.2
                                  ]
                              ]
                          }}
                          arcLinkLabelsSkipAngle={10}
                          arcLinkLabelsTextColor={"#ffffff"}
                          arcLinkLabelsStraightLength={10}
                          arcLinkLabelsColor={{ from: 'color' }}
                          arcLabelsSkipAngle={10}
                          arcLabelsTextColor={(d)=>d.data.textColor}
                          arcLabel={(d)=>`${d.value.toLocaleString('en-US', {maximumFractionDigits:2})}`}
                          legends={[]}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </React.Fragment>
              }
            </Grid>
          </Collapse>
        </TableCell>
      </TableRow>
      <Popover
        className={classes.popover}
        open={illegalOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        elevation={0}
      >
        <div style={{padding:'1em',minWidth:'220px'}}>
          <Typography variant="h5" style={{color:TeamColors[player.team || 0]}}>{currPlayer?.name}</Typography>
          {currPlayer.cillegal &&
            <React.Fragment>
              {(currPlayer?.icaa?.length || 0) > 0 &&
                  <React.Fragment>
                    <Typography variant="h6" style={{color:colors.red[500]}}>Banned AA</Typography>
                    <Typography variant="subtitle1" style={{color:'#b7b7b7'}}>Remove or Replace the below AAs.</Typography>
                    {currPlayer?.icaa?.map((item)=>{
                      return <div key={item} style={{color:colors.orange[500]}}>{item}</div>
                    })}
                    <br />
                  </React.Fragment>
                }
                {currPlayer?.iguild != "" &&
                  <React.Fragment>
                    <Typography variant="h6" style={{color:colors.red[500]}}>Guild</Typography>
                        <Typography variant="subtitle1" style={{color:'#b7b7b7'}}>Guilds are not allowed in pvp.  To fix this issue leave your guild then open the guild management window again.</Typography>
                        <span  style={{color:colors.orange[500]}}>{currPlayer?.iguild}</span>
                    <br />
                  </React.Fragment>
                }
                {(currPlayer?.ciequip?.length || 0) > 0 &&
                  <React.Fragment>
                    <Typography variant="h6" style={{color:colors.red[500]}}>Banned Items</Typography>
                        <Typography variant="subtitle1" style={{color:'#b7b7b7'}}>Remove or Replace the below items.</Typography>
                    {currPlayer?.ciequip?.map((item)=>{
                      return <div key={item} style={{color:colors.orange[500]}}>
                      <ItemComponent item={item} rarity={"Legendary"} key={item} />
                    </div>
                    })}
                    <br />
                  </React.Fragment>
                }
                {(currPlayer?.ciabilities?.length || 0) > 0 &&
                  <React.Fragment>
                    <Typography variant="h6" style={{color:colors.red[500]}}>Banned Buffs</Typography>
                    <Typography variant="subtitle1" style={{color:'#b7b7b7'}}>Remove any buffs by right clicking them on the buff bar at the top of aoc.</Typography>
                    {currPlayer?.ciabilities?.map((item)=>{
                      return <div key={item} style={{color:colors.orange[500]}}>{item}</div>
                    })}
                    <br />
                  </React.Fragment>
                }
            </React.Fragment>
          }
          <br />
          <Typography variant="h6">Illegal History</Typography>
          <hr />
          <React.Fragment>
            {(currPlayer?.iaa?.length || 0) > 0 &&
                <React.Fragment>
                  <Typography variant="h6" style={{color:colors.red[500]}}>Banned AA</Typography>
                  {currPlayer?.iaa?.map((item)=>{
                    return <div key={item} style={{color:colors.orange[500]}}>{item}</div>
                  })}
                  <br />
                </React.Fragment>
              }
              {currPlayer?.iguild != "" &&
                <React.Fragment>
                  <Typography variant="h6" style={{color:colors.red[500]}}>Guild</Typography>
                  <span  style={{color:colors.orange[500]}}>{currPlayer?.iguild}</span>
                  <br />
                </React.Fragment>
              }
              {(currPlayer?.iequip?.length || 0) > 0 &&
                <React.Fragment>
                  <Typography variant="h6" style={{color:colors.red[500]}}>Banned Items</Typography>
                  {currPlayer?.iequip?.map((item)=>{
                    return <div key={item} style={{color:colors.orange[500]}}>
                    <ItemComponent item={item} rarity={"Legendary"} key={item} />
                  </div>
                  })}
                  <br />
                </React.Fragment>
              }
              {(currPlayer?.iabilities?.length || 0) > 0 &&
                <React.Fragment>
                  <Typography variant="h6" style={{color:colors.red[500]}}>Banned Buffs</Typography>
                  {currPlayer?.iabilities?.map((item)=>{
                    return <div key={item} style={{color:colors.orange[500]}}>{item}</div>
                  })}
                  <br />
                </React.Fragment>
              }
            </React.Fragment>
        </div>
        
      </Popover>
    </React.Fragment>
  );
}

interface PieData {
  id: string;
  label: string;
  value: number;
  color: string;
  textColor: string;
  class: string;
}

export const getTeamScores = (players: IGamePlayer[]) => {
  let newTeamScores:Array<PlayerScore[]> = [];
  
  let teamOptions = _.uniqBy(players,(player)=>player.team);
  
  teamOptions.filter((player)=>player.team != null).sort((a,b)=> (a.team || 0) - (b.team || 0)).forEach((playerFiltered)=>{
    let playerScores: PlayerScore[] = players?.filter((p)=>p.team == playerFiltered.team).map((player)=>{
      return {
        character_id: player.character?._id,
        name: player.name || "",
        class: player.class || "",
        team: player.team,
        kills: player.kills || 0,
        deaths: player.deaths || 0,
        assists: player.assists || 0,
        eAssists: player.eAssists || 0,
        eKills: player.eKills || 0,
        captain: player.captain || false
      }
    }) || [];
    newTeamScores.push(playerScores);
  });
  if(teamOptions.some((player)=>player.team == null))
    newTeamScores.push(players?.filter((p)=>p.team == null).map((player)=>{
      return {
        character_id: player.character?._id,
        name: player.name || "",
        class: player.class || "",
        team: player.team,
        benched: player.benched || false,
        kills: player.kills || 0,
        deaths: player.deaths || 0,
        assists: player.assists || 0,
        eAssists: player.eAssists || 0,
        eKills: player.eKills || 0,
        captain: player.captain || false
      }
    }) || []);
  return newTeamScores;
}

const GameScoreComponent: React.FC<Props> = ({teamScores,game}) => {
  const classes = useStyles();
  const {players,deaths,info} = game;
  const matches = useMediaQuery(`(max-width:${1350}px)`);
  const mobile = useMediaQuery(`(max-width:${500}px)`);

  return (
    <React.Fragment>
      {teamScores.map((team, teamIndex)=>{
        let kills = team.map((player)=>player.kills).reduce((sum, curr) => sum + curr);
        let _deaths = team.map((player)=>player.deaths).reduce((sum, curr) => sum + curr);
        let assists = team.map((player)=>player.assists).reduce((sum, curr) => sum + curr);
        let hasTime = players?.find((p)=>p.timeInObjective != null && p.timeInObjective > 0) != null;
        let playersWaiting = team[0].team == null;
        // proving grounds: players benched for not fighting at the end of the match
        let benched = playersWaiting && team.every((player: any)=>player.benched);
        return <div className="score-team-container">
          <TableContainer component={Paper} className={classes.background}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2} classes={{root:classes.cellRoot}} style={{marginLeft:'5px'}}>
                    <div className={!mobile ? "score-team-header" : "score-team-header-mobile"}>
                      <div className="team-color-circle" style={{backgroundColor:TeamColors[playersWaiting ? TeamColors.length - 1 : teamIndex]}}></div>
                      <div style={{gridArea:'team'}} title={benched ? 'Dealt no damage in the last 4 minutes of the match: not on a team, no MMR change' : undefined}>{playersWaiting ? (benched ? 'Benched (inactive)' : 'Players Waiting') : `Team ${teamIndex + 1}`}</div>
                      <div style={{gridArea:'kda'}} className="score-team-kda">
                        {!playersWaiting && <span className="score-team-score" style={{color: TeamColors[teamIndex]}}>{game?.teams && game?.teams[teamIndex]?.score}</span>}
                        <span title="Kills / Deaths / Assists">{kills} / {_deaths} / {assists}</span>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align={"center"} className={classes.statHeader} classes={{root:classes.cellRoot}}>K</TableCell>
                  <TableCell align={"center"} className={classes.statHeader} classes={{root:classes.cellRoot}}>D</TableCell>
                  <TableCell align={"center"} className={classes.statHeader} classes={{root:classes.cellRoot}}>A</TableCell>
                  <TableCell align={"center"} className={classes.statHeader} classes={{root:classes.cellRoot}}>eK</TableCell>
                  <TableCell align={"center"} className={classes.statHeader} classes={{root:classes.cellRoot}}>eA</TableCell>
                  {!matches &&
                    <React.Fragment>
                      <TableCell align={"center"} classes={{root:classes.cellRoot}}>
                        <div className={classes.iconContainer}>
                          <Sword width={20} style={{fill: '#FFF'}} />
                        </div>
                      </TableCell>
                      <TableCell align={"center"} classes={{root:classes.cellRoot}}>
                        <div className={classes.iconContainer}>
                          <Shield width={20} style={{fill: '#FFF'}} />
                        </div>
                      </TableCell>
                      <TableCell align={"center"} classes={{root:classes.cellRoot}}>
                        <div className={classes.iconContainer}>
                          <Cross width={20} style={{fill: '#FFF'}} />
                        </div>
                      </TableCell>
                      {hasTime && <TableCell align={"center"} classes={{root:classes.cellRoot}}>
                        <div className={classes.iconContainer}>
                          <Timer />
                        </div>
                      </TableCell>}
                    </React.Fragment>
                  }
                  <TableCell classes={{root:classes.cellRoot}}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {team.map((_p) => {
                  let perf = players?.find((p)=>p.name == _p.name);
                  return (
                    perf ? <Row key={perf?.name} row={_p} player={perf} game={game} matches={matches} /> : <div></div>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      })}
    </React.Fragment>
    
  )
}

// Memoized: the game views re-render several times a second (position / team location ticks)
// while these props only change when the game data itself changes.
export const GameScore = React.memo(GameScoreComponent);
